import './dropArrow.css';

export default function DropArrow() {
    return(
        <div>
            <svg width="19.078" height="11.805" viewBox="0 0 19.078 11.805">
                <path id="Icon_ion-ios-arrow-back" data-name="Icon ion-ios-arrow-back" d="M14.171,14.664l6.411-6.406a1.211,1.211,0,0,0-1.715-1.71L11.6,13.806a1.209,1.209,0,0,0-.035,1.67l7.294,7.309a1.211,1.211,0,1,0,1.715-1.71Z" transform="translate(-5.06 21.938) rotate(-90)" fill="#72bf72" stroke="#72bf72" stroke-width="2"/>
            </svg>
        </div>
    )
}